
export function doubleDigit(value){
    if((value+'').length == 2){
        return value+'';
    }else{
        return '0'+value;
    }
}

export function getUrlEncodedDateTime(date){
    var output = date.getUTCFullYear()+'-'+
        doubleDigit(date.getUTCMonth()+1)+'-'+
        doubleDigit(date.getUTCDate())+' '+
        doubleDigit(date.getUTCHours())+':'+
        doubleDigit(date.getUTCMinutes())+':'+
        doubleDigit(date.getUTCSeconds());
    return output;
}

export function getUrlEncodedMeasurementHourFile(date){
    var output = date.getUTCFullYear()+'-'+
                doubleDigit(date.getUTCMonth()+1)+'-'+
                doubleDigit(date.getUTCDate())+'-'+
                doubleDigit(date.getUTCHours());
    return output;
}

export function getUrlEncodedMeasurementDayFile(date){
    var output = date.getUTCFullYear()+'-'+
                doubleDigit(date.getUTCMonth()+1)+'-'+
                doubleDigit(date.getUTCDate()); //tule
    return output;
}

export function addDays(date, days) { 
    var result = new Date(date); 
    result.setDate(result.getDate() + days); 
    return result; 
} 

export function getWeekDays(day){
    //var day = new Date();
    var weekDay = day.getDay();
    if (weekDay == 0) { weekDay = 7}
    var days = [];
    for(var i = 0; i < 7;i++){
        days.push(getUrlEncodedMeasurementDayFile(addDays(day, (i+1)-weekDay)));
    }
    return days;
}

/* SETTINGS */

export function mutateLocalSettings(settings, screenSize){
    //region interface
    settings.interface.syncgraphs = (settings.interface.syncgraphs==1)?true:false;

    settings.interface.rtvaluesPicker = new Date(2017,1,1,0,0,settings.interface.rtvalues);

    settings.interface.RangNOtype = settings.interface.RangNOtype;
    settings.interface.RangNO = settings.interface.RangNO.split(',');

    settings.interface.RangSPtype = settings.interface.RangSPtype;
    settings.interface.RangSP = settings.interface.RangSP.split(',');

    settings.interface.RangWEtype = settings.interface.RangWEtype;
    settings.interface.RangWE = settings.interface.RangWE.split(',');

    settings.interface.RangADIOtype = settings.interface.RangADIOtype;
    settings.interface.RangADIO = settings.interface.RangADIO.split(',');

    settings.interface.noise = 1;
    settings.interface.adio = 1;
    settings.interface.statistics = 1;

    /*Mobile preload*/
    console.log('Screen size', screenSize);
    if(screenSize < 2){
        settings.interface.preloadNoise = 1;
        settings.interface.preloadAdio = 1;
        settings.interface.preloadWeather = 1;
        settings.interface.preloadStatistics = 1;
        settings.interface.preloadSpectrum = 1;
    }else{
        settings.interface.preloadNoise = 0;
        settings.interface.preloadAdio = 0;
        settings.interface.preloadWeather = 0;
        settings.interface.preloadStatistics = 0;
        settings.interface.preloadSpectrum = 0;
    }

    
    settings.interface.colorsweath = settings.interface.colorsweath.split(',');
    settings.interface.colorsnoise = settings.interface.colorsnoise.split(',');
    settings.interface.colorsspecial = settings.interface.colorsspecial.split(',');
    var colorsnoiseCount = settings.interface.colorsnoise.length;
    if(colorsnoiseCount<17){
        for(var i = 0; i < 17-colorsnoiseCount; i++){
            settings.interface.colorsnoise.push(settings.interface.colorsnoise[i%colorsnoiseCount]);
        }
    }
    settings.interface.showNoiseTriggerLevel = true;
    settings.interface.showSpectrumTriggerLevel = true;
    //endregion 
    
    /*Statistics download */
    settings.download.statistics = {
        mapping : {}
    }



    settings.download.downlnoise = settings.download.downlnoise.split(',');
    var downlnoise = {};
    settings.download.downlnoise.forEach(item=>{
        downlnoise[item] = true;
    })
    settings.download.downlnoise = downlnoise;

    settings.download.downlweath = settings.download.downlweath.split(',');
    var downlweath = {};
    settings.download.downlweath.forEach(item=>{
        downlweath[item] = true;
    })
    settings.download.downlweath = downlweath;

    //settings.download.downlGlobal = settings.download.downlGlobal.split(',');
    var downlGlobal = {};
    //settings.download.downlGlobal.forEach(item=>{
    //    downlGlobal[item] = true;
    //})
    settings.download.downlGlobal = downlGlobal;
    
    settings.download.audio = false;
    if (settings.download.downlaudio == 1) {
        settings.download.audio = true;
    }
    settings.download.video = false;
    if (settings.download.downlvideo == 1) {
        settings.download.video = true;
    }
    settings.download.markers = false;

    
}

export function demutateSettings(settings){
    var settings = JSON.parse(JSON.stringify(settings));

    demutateFTP(settings.ftp);
    demutateDevice(settings.device);
    demutateWeather(settings.weather);
    demutateAudio(settings.audio);
    demutateSystem(settings.system)
    demutateSpecval(settings.specval);
    demutateAlerts(settings.alerts)
    demutateVideo(settings.video);
    demutateStatistics(settings.statistics);
    demutateStartstop(settings.startstop);

    return settings;
}

function demutateFTP(s){
    s.valall = s.valall.join(',');
    s.valsel = s.valsel.filter(val=>val.enabled).map(val=>val.name).join(',');
    delete s.oldValsel;
}

function demutateDevice(s){
    var valsel = '';
    s.valall.forEach(val=>{
        if(s.valsel.indexOf(val)>-1){
            valsel+=','+val;
        }
    })
    s.valall = s.valall.join(',');
    s.valsel = valsel.substring(1);
    delete s.valuesAll;
}

function demutateWeather(s){
    if(s.valall.constructor !== Array) return;
    
    s.valall = s.valall.join(',');
    s.valsel = s.valsel.filter(val=>val.enabled).map(val=>val.name).join(',');
    switch(s.windsptrigtype){
        case 0:{s.windsptrig=[-100,-100]; break}
        case 1:{s.windsptrig[1]=-100; break}
        case 2:{s.windsptrig[0]=-100; break}
    }
    s.windsptrig = s.windsptrig.join(',');

    switch(s.temptrigtype){
        case 0:{s.temptrig=[-100,-100]; break}
        case 1:{s.temptrig[1]=-100; break}
        case 2:{s.temptrig[0]=-100; break}
    }
    s.temptrig = s.temptrig.join(',');
    
    switch(s.humidtrigtype){
        case 0:{s.humidtrig=[-100,-100]; break}
        case 1:{s.humidtrig[1]=-100; break}
        case 2:{s.humidtrig[0]=-100; break}
    }
    s.humidtrig = s.humidtrig.join(',');

    switch(s.airprtrigtype){
        case 0:{s.airprtrig=[-100,-100]; break}
        case 1:{s.airprtrig[1]=-100; break}
        case 2:{s.airprtrig[0]=-100; break}
    }
    s.airprtrig = s.airprtrig.join(',');

    switch(s.precipittrigtype){
        case 0:{s.precipittrig=[-100,-100]; break}
        case 1:{s.precipittrig[1]=-100; break}
        case 2:{s.precipittrig[0]=-100; break}
    }
    s.precipittrig = s.precipittrig.join(',');


    if(s.device == 'NaN') {
        s.present = 0;
    } else {
        s.present = 1;
    }

    delete s.oldValsel;

    var rectimeTime = new Date(s.rectimePicker);
    s.rectime = rectimeTime.getHours()*3600 + rectimeTime.getMinutes()*60 + rectimeTime.getSeconds();
    delete s.rectimePicker;
}

//DEMUTATE AUDIO MAYBE DOES NOT WORK CORRECTLY FIX IT.
function demutateAudio(s){
    switch(s.threshold1type){
        case 0:{s.threshold1=[-100,140]; s.time1 = ''; s.time1stop = ''; break}
        case 1:{s.threshold1[1]=140; break}
        case 2:{s.threshold1[0]=-100; break}
    }
    s.threshold1 = s.threshold1.join(',');
    
    switch(s.threshold2type){
        case 0:{s.threshold2=[-100,140]; s.time2 = ''; s.time2stop = '';  break}
        case 1:{s.threshold2[1]=140; break}
        case 2:{s.threshold2[0]=-100; break}
    }
    s.threshold2 = s.threshold2.join(',');
    s.time2 = s.time1stop;
    s.time2stop = s.time1;
    
    switch(s.threshold3type){
        case 0:{s.threshold3=[-100,140]; s.time3 = ''; s.time3stop = ''; break}
        case 1:{s.threshold3[1]=140; break}
        case 2:{s.threshold3[0]=-100; break}
    }
    s.threshold3 = s.threshold3.join(',');
    
    switch(s.threshold4type){
        case 0:{s.threshold4=[-100,140]; s.time4 = ''; s.time4stop = ''; break}
        case 1:{s.threshold4[1]=140; break}
        case 2:{s.threshold4[0]=-100; break}
    }
    s.threshold4 = s.threshold4.join(',');
    
    var duration1Time = new Date(s.duration1Picker);
    s.duration1 = duration1Time.getHours()*3600 + duration1Time.getMinutes()*60 + duration1Time.getSeconds();
    delete s.duration1Picker;

    var duration2Time = new Date(s.duration2Picker);
    s.duration2 = duration2Time.getHours()*3600 + duration2Time.getMinutes()*60 + duration2Time.getSeconds();
    delete s.duration2Picker;

    var duration3Time = new Date(s.duration3Picker);
    s.duration3 = duration3Time.getHours()*3600 + duration3Time.getMinutes()*60 + duration3Time.getSeconds();
    delete s.duration3Picker;

    var duration4Time = new Date(s.duration4Picker);
    s.duration4 = duration4Time.getHours()*3600 + duration4Time.getMinutes()*60 + duration4Time.getSeconds();
    delete s.duration4Picker;

}

function demutateSystem(s){
    s.delvalall = s.delvalall.join(',');
    s.delvalsel = s.delvalsel.filter(val=>val.enabled).map(val=>val.name).join(',');
    delete s.delvalselOld;

    
}

function demutateSpecval(s){
    s.valallsp = s.valallsp.join(',');
    s.valselsp = s.valselsp.filter(val=>val.enabled).map(val=>val.name).join(',');
    s.global = s.global.join(',');

    switch(s.mavalltype){
        case 0:{s.mavallevel=[-100,-100]; break}
        case 1:{s.mavallevel[1]=-100; break}
        case 2:{s.mavallevel[0]=-100; break}
    }
    s.mavallevel = s.mavallevel.join(',');
    
    delete s.oldvalselsp;

    var mavaldurationTime = new Date(s.mavaldurationPicker);
    s.mavalduration = mavaldurationTime.getHours()*3600 + mavaldurationTime.getMinutes()*60 + mavaldurationTime.getSeconds();
    delete s.mavaldurationPicker;
}

function demutateAlerts(s){
    s.groups.forEach(g=>{
        var id = g.replace('gr','');
        
        s['recpg'+id] = s['recpg'+id].join(',');
        
    

        var alg = [];
        Object.keys(s['alg'+id]).forEach(k=>{
            if(s['alg'+id][k]){
                alg.push(k);
            }
        })
        s['alg'+id] = alg.join(',');

        s['leqdg'+id] = s['leqdg'+id].join(',');
        delete s['del'+id];

        s['repg'+id] = s['repg'+id].join(',');

        s['lqtg'+id] = s['lqtg'+id].join(',');
        
        //s['recpg'+id] = s['recpg'+id].join(',');
        
    })
    s.groups = s.groups.join(',');
}

function demutateVideo(s){
}

function demutateStatistics(s){
    if(!s) return;
    s.groups = s.allgroups.join(',');


    s.allgroups.forEach(g=>{
        let id = g.replace('st','');
        s['dayss'+id] = s['dayss'+id].join(',');
        s['ranges'+id]  = s['ranges'+id].join(',');
    })

    delete s.allgroups;


}

function demutateStartstop(s){
    
    s.groups.forEach(g=>{
        s['days'+g] = s['days'+g].join(',');
        s['types'+g] = s['types'+g].join(',');
        s['enable'+g] = (s['enable'+g]) ? '1':'0';
    })

    s.groups = s.groups.join(',');
}


// WEBPACK FOOTER //
// ./src/common/utils.js